import { DEPLOY_ENV } from 'library-components/config/envConfig.js';
function getOfficialUrl() {
    if (DEPLOY_ENV === 'qa') {
        return 'http://qa-official.patsnap.info/product-demo';
    }
    return 'https://www.zhihuiya.com/product-demo';
}
/**
 * 官网路径
 */
export const OFFICIAL_URL = getOfficialUrl();
/**
 * 帮助中心路径 url
 */
export const HELP_URL_EU = 'https://patsnap.zendesk.com/auth/v2/login/continue_with_sso_tracking?auth_origin=4665402834717%2Cfalse%2Ctrue&brand_id=4665402834717&locale=en-us&remote_auth_id=18719448547741&return_to=https%3A%2F%2Fpatsnap.zendesk.com%2Fhc%2Fen-us&role=end_user&theme=hc';
